import { useTranslation } from 'react-i18next';

import type { PhaseDescription } from '../ProtocolRuleForm.types';

const key = (name: string) => `adminPortal.protocols.ruleForm.summary.${name}`;

/**
 * A phase in words, its weeks first: "week 1 t/m week 4 6× per week", "week 5 4× totaal". Shared by
 * the live summary and a folded phase, so both always read the same.
 */
export const useFormatPhase = () => {
  const { t } = useTranslation('common');

  return ({ kind, amount, interval, start, end }: PhaseDescription) => {
    const range =
      start === end
        ? t(key('week'), { start })
        : t(key('weekRange'), { start, end });
    return `${range} ${t(key(kind), { amount, interval })}`;
  };
};
